import { FC } from 'react';
import { LocalAccount } from '../../../types/LocalAccount';
import { DefaultCell } from '@silverfort/sf-components';

type Props = LocalAccount;

const NameCell: FC<Props> = ({ userName, boundAdEntity }: Props) => {
    return (
        <div className="w-[156px]">
            <DefaultCell text={userName} />
        </div>
    );
};

export default NameCell;
